import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import Lockr from 'lockr'
import prefetch from 'prefetch-image'
import { t } from 'i18next'

import { FETCH_QUESTIONS, UPDATE_USER_QUESTIONS, SHOW_MODAL, EXIST_USER } from './actions'
import { PROXY, USER } from './config'
import Loading from './components/Loading'
import { padding } from './utils'

class App extends Component {
  state = {
    fetched: null,
    new: null
  }

  componentDidMount() {
    const { updateQuestions, showError, user, existUser, language } = this.props
    const questionsURL = language ? `${PROXY}/questions/${language}` : `${PROXY}/questions`

    axios
      .get(`${PROXY}/sanity/${user.id}`)
      .then(response => {
        existUser(true)
      })
      .catch(e => existUser(false))

    axios
      .get(questionsURL)
      .then(response => {
        updateQuestions(response.data)
        // prefetch
        const current = user.progress
        if (current < response.data.length) {
          const width = window.outerWidth
          const display = width < 680 ? 'mobile' : 'desktop'
          const image = `/images/${display}/Imagen_${padding(current + 1)}.jpg`
          prefetch([image])
        }

        this.setState({
          fetched: true
        })
      })
      .catch(error => {
        console.error(error)
        showError()
        this.setState({
          fetched: true
        })
      })
  }

  render() {
    const { children } = this.props
    const { fetched } = this.state

    return fetched ? (
      children
    ) : (
      <Loading width="100vw" height="100vh">
        {t('loading')}
      </Loading>
    )
  }
}

const mapDispatch = dispatch => {
  return {
    updateQuestions: questions => {
      const user = Lockr.get(USER, undefined)
      const current = user.progress
      const newQuestions = current < questions.length

      dispatch({
        type: UPDATE_USER_QUESTIONS,
        payload: questions.length
      })

      dispatch({
        type: FETCH_QUESTIONS,
        payload: {
          questions,
          noQuestions: !newQuestions
        }
      })
    },

    existUser: payload => {
      dispatch({
        type: EXIST_USER,
        payload: { exists: payload }
      })
    },

    showError: () => {
      dispatch({
        type: SHOW_MODAL,
        payload: 'error'
      })
    }
  }
}

const mapState = ({ user }) => {
  return {
    user
  }
}

export default connect(mapState, mapDispatch)(App)



// WEBPACK FOOTER //
// ./src/App.js